/**
 * Persistance locale d'un modèle Backbone vers Dexie.
 */
import Pond from 'model/Pond';
import Visit from 'model/Visit';
import Image from 'model/Image';
import Zone from 'model/Zone';
import * as repo from 'db/repositories';
import { hydratePondFromApi } from 'db/hydrate';

export function persistModel( model )
{
	var json = model.toJSON ? model.toJSON() : model.attributes;

	if( model instanceof Pond )
	{
		return repo.putPond( json );
	}

	if( model instanceof Visit )
	{
		return repo.putVisit( json );
	}

	if( model instanceof Image )
	{
		return repo.putImage( json );
	}

	if( model instanceof Zone )
	{
		return repo.putZone( json );
	}

	return Promise.resolve();
}

/**
 * Charge mare + zone + visites + images pour une page détail.
 * Online : hydrate API → Dexie puis lecture locale.
 */
export function loadPondPage( uuid )
{
	var fromDexie = function()
	{
		return repo.getPond( uuid ).then( function( attrs )
		{
			if( !attrs || attrs.todo === 'delete' )
			{
				return null;
			}

			var pond = new Pond( attrs );

			return Promise.all( [
				attrs.zone_id ? repo.getZone( attrs.zone_id ) : repo.getClosestZone( attrs ),
				repo.getVisitsByPond( uuid ),
				repo.getImagesByPond( uuid ),
			] ).then( function( related )
			{
				pond._zone = related[0];
				pond._visitRows = related[1] || [];
				pond._imageRows = related[2] || [];
				return pond;
			} );
		} );
	};

	return fromDexie().then( function( pond )
	{
		// Offline : fallback Dexie uniquement
		if( !app.is( 'online' ) )
		{
			return pond;
		}

		// Brouillon local : ne pas écraser avec l'API
		if( pond && pond.isSavable && pond.isSavable() )
		{
			return pond;
		}

		// Online : hydrate cache opportuniste puis relire Dexie
		return hydratePondFromApi( uuid ).then( function()
		{
			return fromDexie();
		} );
	} );
}
